import store from "@/store";

export function isCurrentDepartment(department) {
  return store.state.mainRole.team.name === department;
}
